/* eslint-disable no-restricted-syntax */
import { routeNames } from '@/router/constants'

export default [
  {
    name: routeNames.FISH_ZERO_QUERY_SEARCH,
    path: 'search-category/:category/:coord',
    component: () => import('@/components/explore/explore-zero-query-card'),
  },
  {
    name: routeNames.FISH_QUICK_SEARCH,
    path: 'quick-search/:category',
    component: () => import('@/components/quick-search/quick-search-results'),
  },
]
